/* Slideshow con dissolvenza incrociata.
   Autonomo: non estende SliderComponent di Dawn, che deriva la slide attiva
   da slider.scrollLeft e non funziona con le slide impilate. */

class AranceSlideshow extends HTMLElement {
  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('.as-slide'));
    if (this.slides.length === 0) return;

    this.index = 0;
    this.timer = null;
    this.speed = (parseInt(this.dataset.speed, 10) || 5) * 1000;
    this.autoplay =
      this.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    this.currentEl = this.querySelector('.slider-counter--current');
    this.totalEl = this.querySelector('.slider-counter--total');
    this.dots = Array.from(this.querySelectorAll('.slider-counter__link'));
    this.autoplayButton = this.querySelector('.slideshow__autoplay');

    /* Frecce e puntini spostano la slide ma NON spengono l'autoplay: come fa
       Dawn. Fanno ripartire il timer da zero, cosi' la slide scelta resta
       visibile per l'intervallo intero invece di scattare via subito.
       Solo il pulsante pausa ferma davvero la rotazione. */
    this.querySelector('.slider-button--prev')?.addEventListener('click', () => {
      this.select(this.index - 1);
      this.restart();
    });
    this.querySelector('.slider-button--next')?.addEventListener('click', () => {
      this.select(this.index + 1);
      this.restart();
    });
    this.dots.forEach((dot, i) =>
      dot.addEventListener('click', () => {
        this.select(i);
        this.restart();
      })
    );
    this.autoplayButton?.addEventListener('click', () => (this.timer ? this.pause() : this.play()));

    if (this.totalEl) this.totalEl.textContent = this.slides.length;
    this.select(0);

    if (this.slides.length > 1 && this.autoplay) {
      this.play();

      /* Niente pausa al passaggio del mouse: le slide non contengono link, non
         c'e' nulla su cui il puntatore debba fermarsi, e l'hero occupa quasi
         tutto lo schermo — il cursore ci sta sopra quasi sempre e la rotazione
         non partirebbe mai. Dawn la mette in pausa, noi no, di proposito.
         La pausa da tastiera resta: chi naviga con il tab deve poter leggere.
         Il requisito di accessibilita' (poter fermare il movimento) e' coperto
         dal pulsante pausa esplicito. */
      this.addEventListener('focusin', () => this.suspend());
      this.addEventListener('focusout', () => this.resume());
      document.addEventListener('visibilitychange', () =>
        document.hidden ? this.suspend() : this.resume()
      );
    }
  }

  disconnectedCallback() {
    this.stopTimer();
  }

  select(i) {
    const total = this.slides.length;
    this.index = ((i % total) + total) % total;

    this.slides.forEach((slide, n) => {
      const active = n === this.index;
      // aria-hidden e' anche l'aggancio del CSS: unica fonte di verita'.
      slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      if (active) slide.removeAttribute('tabindex');
      else slide.setAttribute('tabindex', '-1');
      slide.querySelectorAll('a, button').forEach((el) => {
        if (active) el.removeAttribute('tabindex');
        else el.setAttribute('tabindex', '-1');
      });
    });

    if (this.currentEl) this.currentEl.textContent = this.index + 1;
    this.dots.forEach((dot, n) => {
      dot.classList.toggle('slider-counter__link--active', n === this.index);
      dot.setAttribute('aria-current', n === this.index ? 'true' : 'false');
    });
  }

  play() {
    if (this.slides.length < 2) return;
    this.stopTimer();
    this.timer = setInterval(() => this.select(this.index + 1), this.speed);
    this.userPaused = false;
    if (this.autoplayButton) {
      this.autoplayButton.classList.remove('slideshow__autoplay--paused');
      this.autoplayButton.setAttribute('aria-label', this.autoplayButton.dataset.pauseLabel);
    }
  }

  /* Pausa esplicita dell'utente: non deve ripartire da sola al mouseleave. */
  pause() {
    this.stopTimer();
    this.userPaused = true;
    if (this.autoplayButton) {
      this.autoplayButton.classList.add('slideshow__autoplay--paused');
      this.autoplayButton.setAttribute('aria-label', this.autoplayButton.dataset.playLabel);
    }
  }

  /* Ripartenza dopo un'interazione con frecce/puntini: ridà l'intervallo
     pieno alla slide scelta, senza toccare la pausa esplicita dell'utente. */
  restart() {
    if (this.autoplay && !this.userPaused) this.play();
  }

  /* Sospensione temporanea (hover, focus, tab in background). */
  suspend() {
    this.stopTimer();
  }

  resume() {
    if (this.autoplay && !this.userPaused && !this.timer && !document.hidden) this.play();
  }

  stopTimer() {
    if (this.timer) clearInterval(this.timer);
    this.timer = null;
  }
}

customElements.define('arance-slideshow', AranceSlideshow);
